import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import BgImg from "../../../images/case-studies/rise-up-king/first-step-cta-back.webp";
import { Link } from "gatsby";
import { StaticImage } from "gatsby-plugin-image";

function Risefirststepcta() {
  return (
    <section className="rise-first-step-cta text_white p-100">
      <Container>
        <div
          className="rise-first-box"
          style={{
            backgroundImage: `url(${BgImg})`,
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        >
          <Row>
            <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="mb-4 mb-md-0">
              <h2>
                Take the First Step Towards Your Success: Join the{" "}
                <span className="text-rise-yellow">Rise Up Kings</span> Movement
              </h2>
              <Link
                to="/contact"
                className="border_btn rise-up-btn"
                aria-label="TekRevol Contact"
              >
                Join Us Today
              </Link>
            </Col>
            <Col
              xs={12}
              md={6}
              lg={6}
              xl={6}
              xxl={6}
              className="my-auto text-center"
            >
              <StaticImage
                src="../../../images/case-studies/rise-up-king/first-step-img.webp"
                alt="TekRevol"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={2933}
                height={3000}
              />
            </Col>
          </Row>
        </div>
      </Container>
    </section>
  );
}

export default Risefirststepcta;
